import List from '@common/lib/List';

const mutation = {
  initialReset(state) {
    state.list = [];
    state.parentList = {};
    state.bidsList = [];
    state.filter = {};
    state.filter.page = 1;
    state.hasEmpty = false;
    state.isLoading = false;
  },
  resetParentList(state) {
    state.parentList = {};
  },
  paginationCheck(state, status) {
    state.isPaginating = status;
  },
  setLoading(state, status) {
    state.isLoading = status;
  },
  setPage(state, data) {
    state.filter.page = data;
  },
  setList(state, data) {
    const parents = data.reduce((acc, indent) => {
      if (!state.parentList.hasOwnProperty(indent._id)) {
        state.parentList[indent._id] = true;
        acc.push(indent);
      }
      return acc;
    }, []);
    const result = (state.filter.page > 1) ? state.list.concat(parents) : parents;
    state.list = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setBidsList(state, data) {
    const result = (state.filter.page > 1) ? state.bidsList.concat(data) : data;
    state.bidsList = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setFirstInTransporterList(state, data) {
    const result = (state.filter.page > 1) ? state.firstInTransporterList.concat(data) : data;
    state.firstInTransporterList = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setIndents(state, data) {
    // eslint-disable-next-line no-underscore-dangle
    if (data._id && state.parentList[data._id]) {
      state.list = List.update(state.list, data, '_id');
    } else {
      const indents = state.list;
      state.list = indents.map((indent) => {
        const currIndent = indent;
        if (indent.returnIndents && indent.returnIndents.length) {
          currIndent.returnIndents = indent.returnIndents.map(
            // eslint-disable-next-line no-underscore-dangle
            returnIndent => (returnIndent._id === data._id ? data : returnIndent));
        }
        return currIndent;
      });
    }
  },
  setBids(state, data) {
    state.bidsList = List.update(state.bidsList, data);
  },
  removeIndent(state, orderNo) {
    const currentIndent = state.list.find(ind => ind.order_no !== orderNo);
    if (!currentIndent) { return; }
    const indents = state.list.filter(ind => ind.order_no !== orderNo);
    // eslint-disable-next-line no-underscore-dangle
    delete state.parentList[currentIndent._id];
    state.list = indents.map((indent) => {
      if (!indent.returnIndents) {
        return indent;
      }
      const currIndent = indent;
      currIndent.returnIndents = indent.returnIndents.filter(
        returnIndent => returnIndent.order_no !== orderNo);
      return currIndent;
    });
  },
  setReturnIndents(state, { data, masterOrderId }) {
    const allOrder = state.list;
    const masterIndex = state.list.findIndex(val => val._id === masterOrderId);
    if (masterIndex !== -1) {
      allOrder[masterIndex] = {
        ...allOrder[masterIndex],
        returnIndents: { ...data, ...{ parentIndentId: allOrder[masterIndex].id } },
      };
      // eslint-disable-next-line no-underscore-dangle
      if (data._id) {
        allOrder[masterIndex] = {
          ...allOrder[masterIndex],
          // eslint-disable-next-line no-underscore-dangle
          ...{ child_indent_ids: [data._id] },
        };
      }
      state.list = [...allOrder];
    }
  },
  setCanShowSaveGRN(state, data) {
    state.canShowSaveGRN = data;
  },
  setReturnMaterialDetails(state, data) {
    state.returnMaterialDetails = data;
  },
  setReturnMaterialsWarnedOnce(state, data) {
    state.returnMaterialsWarnedOnce = data;
  },
  hasUserEdited(state, data) {
    state.userEdited = data;
  },
  hasWarnedOnce(state, data) {
    state.warnedOnce = data;
  },
  setuploadStatus(state, status) {
    state.isUploading = status;
  },
  setIndentRepublishRequestsList(state, data) {
    const result = (state.filter.page > 1) ? state.indentRepublishRequests.concat(data) : data;
    state.indentRepublishRequests = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
};

export default mutation;
